export const WeatherImpactActionTypes = {
    API_RESPONSE_SUCCESS: '@@weather-impact/API_RESPONSE_SUCCESS',
    API_RESPONSE_ERROR: '@@weather-impact/API_RESPONSE_ERROR',
    GET_SUMMARY_REQUEST: '@@weather-impact/GET_SUMMARY_REQUEST',
    GET_EVENT_MIX_REQUEST: '@@weather-impact/GET_EVENT_MIX_REQUEST',
    GET_CARRIER_PERFORMANCE_REQUEST: '@@weather-impact/GET_CARRIER_PERFORMANCE_REQUEST',
    GET_SHIPMENT_REPORT_REQUEST: '@@weather-impact/GET_SHIPMENT_REPORT_REQUEST',
    GET_WAREHOUSE_IMPACT_REQUEST: '@@weather-impact/GET_WAREHOUSE_IMPACT_REQUEST',
    GET_EVENT_SUMMARY_REQUEST: '@@weather-impact/GET_EVENT_SUMMARY_REQUEST',
    GET_MAP_REQUEST: '@@weather-impact/GET_MAP_REQUEST',
};
